import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import {
    doRequest
} from '../../../../actions';
import { FormattedMessage, useIntl } from 'react-intl';


import Outcome from '../../../elements/Outcome';

const mapStateToProps = state => ({
    data: state.data,
    system: state.system,
});

const mapDispatchToProps = (dispatch) => ({
    editSystem: (payload, id) => dispatch(doRequest('patchSystem', { payload, id })),
});

const _Personalizza = ({ system, editSystem, data }) => {
    const codeForm = useRef(null);
    const gExtEnabled = system.brand === 'lince-europlus';
    const [errors, setErrors] = useState("");
    const [processed, setProcessed] = useState(false);
    const [success, setSuccess] = useState(false);
    const intl = useIntl();

    const handleSubmit = (e) => {
        e.preventDefault();
        setSuccess(false);
        setProcessed(true);
        const form = codeForm.current;
        let payload = {
            g1: form['g1'].value,
            g2: form['g2'].value,
            g3: form['g3'].value
        };
        if (gExtEnabled) {
            payload.gext = form['gext'].value;
        }
        editSystem(payload, system.id);
    };

    if (data && processed) {
        setErrors("");
        setProcessed(false);
        setSuccess(true);
    }

    if (!!!system) {
        return (<></>);
    }
    return (
        <section>
            <div className="innerSection">
                {
                    success
                        ? (
                            <Outcome text={intl.formatMessage({ id: "App.info.OperazioneEffettuataConSuccesso" })} type="ok" onClose={setSuccess} />
                        )
                        : !!errors && errors.length
                            ? <Outcome text={errors} type="ko" onClose={setErrors} />
                            : <></>
                }
                <div className="rack">
                    <div className="w100 formSection">
                        <form ref={codeForm}>
                            <h3>
                                <FormattedMessage id="App.info.PersonalizzaNomeProgrammi" />
                            </h3>
                            <br />
                            <fieldset>
                                <br />
                                <div className="rack">
                                    <div className="w100 customRows">
                                        <blockquote className="programLabel red">
                                            <FormattedMessage id="App.info.G1" />
                                        </blockquote>
                                        <input type="text" maxLength={15} name="g1" defaultValue={system.g1 || ``} />
                                    </div>
                                </div>
                                <div className="rack">
                                    <div className="w100 customRows">
                                        <blockquote className="programLabel yellow">
                                            <FormattedMessage id="App.info.G2" />
                                        </blockquote>
                                        <input type="text" maxLength={15} name="g2" defaultValue={system.g2 || ``} />
                                    </div>
                                </div>
                                <div className="rack">
                                    <div className="w100 customRows">
                                        <blockquote className="programLabel green">
                                            <FormattedMessage id="App.info.G3" />
                                        </blockquote>
                                        <input type="text" maxLength={15} name="g3" defaultValue={system.g3 || ``} />
                                    </div>
                                </div>
                                {gExtEnabled && (
                                    <div className="rack">
                                        <div className="w100 customRows">
                                            <blockquote className="programLabel blue">
                                                <FormattedMessage id="App.info.Gext" />
                                            </blockquote>
                                            <input type="text" maxLength={15} name="gext" defaultValue={system.gext || ``} />
                                        </div>
                                    </div>
                                )}
                                <div className="rack">
                                    <div className="w100 right">
                                        <button className="ok auto spaced" onClick={handleSubmit}>
                                            <FormattedMessage id="App.info.Salva" />
                                        </button>
                                    </div>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
            <p>&nbsp;</p>
        </section >
    );
};

const Personalizza = connect(mapStateToProps, mapDispatchToProps)(_Personalizza);

export default Personalizza;